import { assign } from 'xstate';

import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const clearPendingAddToBag: CustomizationMachineAction = assign({
  shouldAddToBagWhenReady: false,
});
